import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import TwilioSegmentImage from './TwilioSegmentImage'

const copy = {
  heading: `Twilio + Segment are better together with Twilio Engage`,
  description: `Twilio Engage combines Twilio’s scalable, reliable communication APIs with Segment’s world-class customer data infrastructure, so you can design personalized omnichannel campaigns across all channels.`,
}

const link = {
  text: `Learn more`,
  href: `/product/twilio-engage/`,
}

const TwilioSegment: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <SectionBase variant="noCopy">
        <Section.Contents>
          <ImageWrapper>
            <TwilioSegmentImage />
          </ImageWrapper>
          <StyledCopyTextBase centered={true}>
            <StyledCopyTextHeading variant="h2" tag="h2">
              {copy.heading}
            </StyledCopyTextHeading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
            <CopyText.Link href={getAbsoluteUrl(link.href, pageConfig)}>{link.text}</CopyText.Link>
          </StyledCopyTextBase>
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-bottom: 40px;
  }
`

const ImageWrapper = styled.div`
  padding-bottom: 16px;
  display: flex;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-bottom: 40px;
  }
`

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 844px;
  margin: 0 auto;
`

const StyledCopyTextHeading = styled(CopyText.Heading)`
  max-width: 700px;
  margin: auto;
`

export default TwilioSegment
